package com.cs.ejobin.vm

import com.cs.ejobin.app.AppSession
import com.cs.ejobin.data.supabase.SupabaseExtrasRepository
import com.cs.ejobin.model.Extra
import kotlinx.coroutines.*
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

data class ExtraDetailUiState(
    val isLoading: Boolean = false,
    val error: String? = null,
    val extra: Extra? = null
)

class ExtraDetailViewModel(
    private val extrasRepo: SupabaseExtrasRepository,
    val session: AppSession
) {
    private val scope = CoroutineScope(SupervisorJob() + Dispatchers.Main.immediate)

    private val _state = MutableStateFlow(ExtraDetailUiState(isLoading = true))
    val state: StateFlow<ExtraDetailUiState> = _state.asStateFlow()

    private var loadJob: Job? = null
    private var lastExtraId: String? = null

    // ✅ Paiement désactivé : accès = user connecté (AppSession gère déjà ça)
    fun hasDirectoryAccess(): Boolean = session.state.value.hasDirectoryAccess

    fun load(extraId: String) {
        if (lastExtraId == extraId && _state.value.extra != null) return
        lastExtraId = extraId

        loadJob?.cancel()
        loadJob = scope.launch {
            // ✅ Paiement désactivé : on garde juste la sécurité "connecté"
            if (!hasDirectoryAccess()) {
                _state.value = ExtraDetailUiState(
                    isLoading = false,
                    error = null,
                    extra = null
                )
                return@launch
            }

            _state.value = ExtraDetailUiState(isLoading = true)

            val result = withContext(Dispatchers.Default) {
                runCatching { extrasRepo.getExtra(extraId) }
            }

            result.onSuccess { extra ->
                _state.value = ExtraDetailUiState(isLoading = false, extra = extra)
            }.onFailure { e ->
                _state.value = ExtraDetailUiState(
                    isLoading = false,
                    error = e.message ?: "Erreur de chargement"
                )
            }
        }
    }

    fun retry() {
        lastExtraId?.let { load(it) }
    }

    fun dispose() {
        scope.cancel()
    }
}